/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { toast } from 'react-toastify';
import moment from 'moment';
import _, { filter } from 'lodash';
import Swal from 'sweetalert2';
import {
  getManagerByDepartment,
  getRepFilter,
  getMdStratClass,
  getDepartment,
  getFilterTeams,
} from '../../../api/medRepApi';
import { getFocusGroup } from '../../../api/managerDashboard';
import useManagerContext from '../context/useManagerContext';

const reportViewOptions = [
  { label: 'Daily', value: 'daily' },
  { label: 'Weekly', value: 'weekly' },
];

// const departmentOptions = [
//   { label: 'KASD', value: 'KASD' },
//   { label: 'SAR', value: 'SAR' },
// ];

function Filter() {
  const {
    auth,
    setFilterForm,
    filterForm,
    monthsOptions,
    yearOptions,
    searchManagerDashboard,
    clearManagerDashboard,
    dropdownDisabled,
  } = useContext(useManagerContext);

  const [managerOptions, setManagerDrowndown] = useState([]);
  const [repsOptions, setRepsDrowndown] = useState([]);
  const [classOptions, setClassDrowndown] = useState([]);
  const [focusGroupOptions, setFocusGroupDrowndown] = useState([]);
  const [teamsOptions, setTeamsDrowndown] = useState([]);
  const [department, setDepartMent] = useState([]);

  const loadDepartmentDropdown = async () => {
    try {
      // let departmentDropdown;
      const res = await getDepartment();
      const { code, data } = res.data;

      if (code === '200') {
        const dropdownValue = data?.map((row) => ({
          value: row,
          label: row,
        }));

        // if (data.length === 1) {
        //   setFilterForm({ ...filterForm, department: dropdownValue[0] });
        //   departmentDropdown = dropdownValue;
        // } else {
        //   departmentDropdown = [{ label: 'ALL', value: null }, ...dropdownValue];
        // }
        setDepartMent([{ label: 'ALL', value: null }, ...dropdownValue]);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const loadTeamsDropdown = async () => {
    const request = {
      department: filterForm?.department?.value ?? '',
      manager_id: '',
      date_from: filterForm?.date_from,
      date_to: filterForm?.date_to,
      month: [],
      years: [],
      keyword: '',
    };
    const reponse = await getFilterTeams(request);
    const { code, data } = reponse.data;
    if (code === '200') {
      const dropdownValue = data
        ?.filter((row) => row.team !== null)
        .map((row) => ({
          value: row.team,
          label: row.team,
        }));
      setTeamsDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);
      // if (dropdownValue.length < 2) {
      //   setFilterForm({ ...filterForm, team: dropdownValue[0] });
      // } else {
      //   setFilterForm({ ...filterForm, team: { label: 'ALL', value: null } });
      // }
    }
  };

  const loadFocusGroupDropdown = async () => {
    try {
      const res = await getFocusGroup();
      const { code, data } = res.data;

      if (code === '200') {
        const dropdownValue = data?.map((row) => ({
          value: row.id,
          label: row.name,
        }));
        setFocusGroupDrowndown(dropdownValue);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const loadManagersDropdown = async () => {
    try {
      const request = {
        department: filterForm.department.value,
        head_id: '',
        keyword: '',
      };
      const res = await getManagerByDepartment(request);
      const { code, data } = res.data;

      if (code === '200') {
        const dropdownValue = data?.map((row, index) => ({
          value: row.manager_id,
          label: row.manager_name,
        }));
        setManagerDrowndown(dropdownValue);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const loadRepsDropdown = async () => {
    try {
      const request = {
        department: filterForm.department.value,
        team: filterForm.team.value,
        date_from: moment(filterForm?.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm.date_to).format('YYYY-MM-DD'),
        manager_id: filterForm.manager.value ?? '',
        month: [],
        year: [],
        keyword: '',
      };
      const res = await getRepFilter(request);
      const { code, data } = res.data;

      if (code === '200') {
        const dropdownValue = data?.map((row, index) => ({
          value: row.rep_id,
          label: row.rep_name,
        }));
        setRepsDrowndown([{ label: 'ALL', value: null }, ...dropdownValue]);

        if (filterForm?.field_level !== '') {
          // check if strat class is in the dropdown else remove
          const fieldLevelExist = dropdownValue.filter(
            (row) => row.value === filterForm?.field_level?.value,
          );

          // if (!fieldLevelExist.length) {
          //   setFilterForm({ ...filterForm, field_level: '' });
          // }
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const loadStratClassDropdown = async () => {
    try {
      const request = {
        department: filterForm.department.value,
        manager: filterForm.manager.value,
        rep_id: filterForm.field_level.value,
        date_from: moment(filterForm.date_from).format('YYYY-MM-DD'),
        date_to: moment(filterForm.date_to).format('YYYY-MM-DD'),
      };
      const res = await getMdStratClass(request);
      const { code, data } = res.data;

      if (code === '200') {
        const dropdownValue = data?.map((row) => ({
          value: row.basic_info_class,
          label: row.basic_info_class,
        }));
        setClassDrowndown(dropdownValue);

        if (filterForm.strat_class !== '') {
          // check if strat class is in the dropdown else remove
          const stratExist = dropdownValue.filter(
            (row) => row.value === filterForm.strat_class.value,
          );
          if (!stratExist.length) {
            setFilterForm({ ...filterForm, strat_class: '' });
          }
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleChangeDate = (label, value) => {
    const tmpdate = new Date(value);
    const newdate = `${
      tmpdate.getMonth() > 8 ? tmpdate.getMonth() + 1 : `0${tmpdate.getMonth() + 1}`
    }-${
      tmpdate.getDate() > 9 ? tmpdate.getDate() : `0${tmpdate.getDate()}`
    }-${tmpdate.getFullYear()}`;

    const endDate = new Date(filterForm.year.value, filterForm.month.value, 0).toString();
    const selectedMonth = new Date(newdate).getMonth() + 1;

    if (label === 'date_from') {
      setFilterForm({
        ...filterForm,
        date_from: newdate,
        date_to: new Date(tmpdate.getFullYear(), selectedMonth, 0).toString(),
        month: monthsOptions[tmpdate.getMonth()],
        year: { label: tmpdate.getFullYear().toString(), value: tmpdate.getFullYear().toString() },
      });
    }

    if (label === 'date_to') {
      if (filterForm.month.value.toString() !== selectedMonth.toString()) {
        Swal.fire({
          title: ' ',
          text: 'Please select date within selected month',
          icon: 'warning',
        });

        setFilterForm({
          ...filterForm,
          date_to: endDate,
        });
      } else {
        setFilterForm({
          ...filterForm,
          date_to: newdate,
        });
      }
    }
  };

  const handleChangeMonth = (e, newValue) => {
    const startDate = moment(`${filterForm.year.value}-${newValue.value}-01`).toDate();
    const endDate = new Date(filterForm.year.value, newValue.value, 0).toString();
    setFilterForm({ ...filterForm, month: newValue, date_from: startDate, date_to: endDate });
  };

  const handleChangeYear = (e, newValue) => {
    const startDate = moment(`${newValue.value}-${filterForm.month.value}-01`).toDate();
    const endDate = new Date(newValue.value, filterForm.month.value, 0).toString();
    setFilterForm({ ...filterForm, year: newValue, date_from: startDate, date_to: endDate });
  };

  useEffect(() => {
    loadDepartmentDropdown();
    loadTeamsDropdown();
  }, []);

  useEffect(() => {
    loadFocusGroupDropdown();
  }, []);

  useEffect(() => {
    loadRepsDropdown();
    loadStratClassDropdown();
    loadManagersDropdown();
  }, [filterForm]);

  // useEffect(() => {
  //   loadManagersDropdown();
  //   loadStratClassDropdown();
  //   loadRepsDropdown();
  // }, [filterForm]);

  return (
    <Box sx={{ pl: 3, pr: 3, mt: 2 }}>
      <Grid container spacing={2}>
        {department.length > 1 && auth.designation === 'hidden' ? (
          <Grid md={1}>
            <Autocomplete
              disablePortal
              id='department'
              disableClearable
              fullWidth
              options={department}
              // // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Deparment' />}
              size='small'
              value={
                filterForm.department
                  ? department.find((row) => row.value === filterForm.department.value)
                  : null
              }
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'department')}
              // readOnly={dropdownDisabled}
            />
          </Grid>
        ) : (
          ''
        )}

        <Grid md={1}>
          <Autocomplete
            disablePortal
            id='team'
            disableClearable
            fullWidth
            options={teamsOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Teams' />}
            size='small'
            value={filterForm?.team}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'team')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        {auth.level === 'Level 3' || auth.level === 'Level 4' ? (
          <Grid md={2}>
            <Autocomplete
              disablePortal
              id='manager'
              disableClearable
              fullWidth
              options={managerOptions}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => <TextField {...params} label='Managers (KASM/SAM)' />}
              size='small'
              value={filterForm.manager}
              onChange={(e, newValue) => handleChangeFilter(e, newValue, 'manager')}
              sx={{ backgroundColor: '#fff' }}
              readOnly={dropdownDisabled}
            />
          </Grid>
        ) : (
          ''
        )}

        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='field_level'
            disableClearable
            fullWidth
            options={repsOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Specialists' />}
            size='small'
            value={filterForm.field_level}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'field_level')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        <Grid md={1}>
          <Autocomplete
            disablePortal
            id='months'
            disableClearable
            fullWidth
            options={monthsOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Months' />}
            size='small'
            value={
              filterForm.month
                ? monthsOptions.find((row) => row.value === filterForm.month.value)
                : null
            }
            onChange={(e, newValue) => handleChangeMonth(e, newValue)}
          />
        </Grid>

        <Grid md={1}>
          <Autocomplete
            disablePortal
            id='year'
            disableClearable
            fullWidth
            options={yearOptions}
            getOptionLabel={(option) => `${option.label}`}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Year' />}
            size='small'
            value={
              filterForm.year
                ? yearOptions.find((row) => row.value === filterForm.year.value)
                : null
            }
            onChange={(e, newValue) => handleChangeYear(e, newValue)}
          />
        </Grid>

        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='field_level'
            disableClearable
            fullWidth
            options={repsOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Field Level (KASS/SAR)' />}
            size='small'
            value={filterForm.field_level}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'field_level')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        <Grid md={1}>
          <DesktopDatePicker
            label='From'
            inputFormat='MM/DD/YYYY'
            value={filterForm.date_from === '' ? null : filterForm.date_from}
            onChange={(e) => handleChangeDate('date_from', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
            sx={{ marginTop: '10px', backgroundColor: '#fff' }}
            disableFuture
          />
        </Grid>

        <Grid md={1}>
          <DesktopDatePicker
            label='To'
            inputFormat='MM/DD/YYYY'
            value={filterForm.date_to === '' ? null : filterForm.date_to}
            fullWidth
            onChange={(e) => handleChangeDate('date_to', e)}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} />}
          />
        </Grid>

        <Grid md={1}>
          <Autocomplete
            disablePortal
            id='report_view'
            disableClearable
            fullWidth
            options={reportViewOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Report View' />}
            size='small'
            value={
              filterForm.report_view
                ? reportViewOptions.find((row) => row.value === filterForm.report_view.value)
                : null
            }
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'report_view')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        <Grid md={2}>
          <Button variant='contained' color='success' onClick={searchManagerDashboard}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={clearManagerDashboard}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
        <Grid md={1} />
      </Grid>
    </Box>
  );
}

export default Filter;
